import { BrandMark } from "../components/BrandMark";

interface Props {
  onRetry: () => void;
}

export function ErrorScreen({ onRetry }: Props) {
  return (
    <main className="shell flex flex-col items-center justify-center px-6 text-center">
      <BrandMark className="mb-10 h-14 w-auto" />

      <h1 className="text-5xl text-cream">Smoke got in the way.</h1>
      <p className="mt-3 max-w-xs text-cream-dim">
        We couldn't send your rating. Check your signal and try once more.
      </p>

      <button type="button" onClick={onRetry} className="pill-btn pill-btn-primary mt-10 max-w-xs">
        Try again
      </button>
    </main>
  );
}
